import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CheckboxState } from 'src/app/enum/checkbox-state';
import { GenericGridService } from 'src/app/services/grid.service';

@Component({
  selector: 'app-generic-grid',
  templateUrl: './generic-grid.component.html',
  styleUrls: ['./generic-grid.component.scss']
})
export class GenericGridComponent implements OnInit {

  @Input() headersTable: string[] = [];
  @Input() data: any[] = [];
  @Input() fields: string[] = [];
  @Input() tableClass: string;
  @Output() itemSelectedSize = new EventEmitter<number>();

  totalSelected = 0;
  allSelected = false;
  totalItens = 0;
  matchPropertyNumber = false;
  checkboxState = CheckboxState;
  headerCheckboxState: CheckboxState;
  inactiveTag: any;

  constructor(
    private gridService: GenericGridService
    ) { }

  ngOnInit(): void {
    this.headerCheckboxState = CheckboxState.Unchecked;
    this.data = this.data.map(el => ({...el, checked: false}));
    this.inactiveTag = {
      description: 'inactive',
      tooltip: 'envelope.signatory.tooltip.signatoryTypeRoleInactive',
      tooltipPlacement: 'top'
    };

    this.gridService.setDataLength(0);

    this.gridService.getHeaderStateCheckBox().subscribe(x => {
      this.headerCheckboxState = x;
    });
  }

  setCheckAll() {
    this.data = this.data.map(x => ({...x, checked: true}));
    this.headerCheckboxState = this.checkboxState.Checked;
    this.gridService.setTotalSelectedItem(this.data.length);
    this.gridService.setItemSelected(this.data);

  }

  setNotCheckAll() {
    this.data = this.data.map(x => ({...x, checked: false}));
    this.headerCheckboxState = this.checkboxState.Unchecked;
    this.gridService.setTotalSelectedItem(0);
  }

  selectedItem(item: any) {
    const totalItens = this.data.length;

    this.data.find(obj => obj.id === item.id).checked = !item.checked;
    this.totalSelected = this.data.filter(el => el.checked).length;
    const allSelected = this.data.filter(el => el.checked);

    if(this.totalItens !== this.totalSelected) {
      this.headerCheckboxState = this.checkboxState.Unchecked;
    }

    if(this.totalItens !== this.totalSelected && this.totalSelected !== 0) {
      this.headerCheckboxState = this.checkboxState.Indeterminate;
    }
    if(allSelected.length === 0) {
      this.headerCheckboxState = this.checkboxState.Unchecked;
    }

    if(this.totalSelected !== 0 && this.totalSelected === totalItens) {
      this.headerCheckboxState = this.checkboxState.Checked;
    }

    this.gridService.setTotalSelectedItem(this.totalSelected);
    this.gridService.setItemSelected(allSelected);
    this.setOptionSelected();
  }

  totalItensSelected() {
    this.itemSelectedSize.emit(this.totalSelected);
  }

  returnZero() {
    return 0;
  }

  isBoolean(property: any) {
    return typeof property === 'boolean';
  }

  findField(key: string): boolean{
    return this.fields.findIndex(x => x == key) > -1;
  }

  isSubscriberTypeRoleField(key: string): boolean {
    return key === 'subscriberTypeValue';
  }

  showSignatoryTypeRoleInactiveTag(item: any): boolean {
    return !!item?.signatoryTypeRole && item?.signatoryTypeRole?.isActive === false;
  }

  setOptionSelected() {
    const item = this.data.find(x => x.checked);
    this.gridService.setOptionSelected(item);
  }
}